// AgentScope (AIAgent_Scopes) sub-entity client — restores the "Scopes" Agent tab dropped in the
// 2026-08-19/20 AgentEditor.tsx refactor. Targets the real live backend
// (BizFirst.Ai.AiAgent.Api.Base's BaseAgentScopeController), verified by reading the controller
// and entity directly.
//
// ROUTE DRIFT FOUND — the task's own briefing guessed `/api/v1/ai-agent/scopes`. Reading
// BaseAgentScopeController.cs directly shows `[Route("api/v1/ai-agent/agent-scopes")]` —
// `/agent-scopes`.
//
// Fields confirmed exactly as briefed: AgentScope.cs is a bare junction row — AgentID + a
// required ScopeTypeID FK, nothing else. No ScopeName/string ScopeType/ScopeDescription/
// ScopePermissions/IsActive.
//
// getScopesByAgent posts to `by-agent` (confirmed on BaseAgentScopeController.cs), same
// `{ AgentID: { ID } }` shape as every other by-agent query in this package.

import { BaseAdminApiClient, type AdminApiConfig, type AdminApiResult } from './baseAdminApiClient';
import type { AgentScopeDTO, AgentScopeFormValues } from '../types';

export class AgentScopeAdminApiClient extends BaseAdminApiClient {
  constructor(config: AdminApiConfig) {
    super(config);
  }

  async getScopesByAgent(agentId: number): Promise<AdminApiResult<AgentScopeDTO[]>> {
    const result = await this.postQuery<AgentScopeDTO[]>('/api/v1/ai-agent/agent-scopes/by-agent', {
      AgentID: { ID: agentId },
      PageInfo: { PageNumber: 1, PageSize: 1000 },
    });
    return { ...result, data: Array.isArray(result.data) ? result.data : [] };
  }

  async createScope(agentId: number, scope: AgentScopeFormValues): Promise<AdminApiResult<AgentScopeDTO>> {
    return this.post<AgentScopeDTO>('/api/v1/ai-agent/agent-scopes', { AgentID: agentId, ...scope });
  }

  async updateScope(agentScopeId: number, scope: Partial<AgentScopeFormValues>): Promise<AdminApiResult<AgentScopeDTO>> {
    return this.put<AgentScopeDTO>(`/api/v1/ai-agent/agent-scopes/${agentScopeId}`, {
      AgentScopeID: agentScopeId,
      ...scope,
    });
  }

  async deleteScope(agentScopeId: number): Promise<AdminApiResult<void>> {
    return this.del<void>(`/api/v1/ai-agent/agent-scopes/${agentScopeId}`, { id: agentScopeId });
  }
}
